var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"c-automator__button l-automator__button fas",on:{"click":_vm.emitClick}})}
var staticRenderFns = []

export { render, staticRenderFns }